// src/hooks/useVouchSession.ts
import { fetchVouchSession } from "@/services";
import { useQuery } from "@tanstack/react-query";

export function useVouchSession(vouchId: string) {
  return useQuery({
    queryKey: ["vouch-session", vouchId],
    queryFn: () => fetchVouchSession(vouchId),
    staleTime: 5 * 60 * 1000,
    // retry: 1,
    refetchOnWindowFocus: false,
  });
}
